export const SmartCampaignRoute = {
  SMARTCAMPAIGNS: 'smartcampaigns',
};

export const SmartCampaignPathName = {
  SMARTCAMPAIGNS: 'smartcampaigns',
  SMARTCAMPAIGNFORM_NEW: 'smartcampaignform:new',
  SMARTCAMPAIGNFORM: 'smartcampaignform',
};

export const SmartCampaignConstants = {
  CAMPAIGN_TYPE: 'campaign_type',
  TYPE: {
    FILTERING: 'filtering',
    GROUPING: 'grouping',
  },
};
export const SmartCampaignQuickFilters = {
  ALL: 'active',
  CHECKED: 'checked',
  UNCHECKED: 'unchecked',
};
